import _defineProperty from '@babel/runtime/helpers/defineProperty';
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import axios from 'axios';
import qs from 'qs';
var service = axios.create({
    baseURL: '/',
    timeout: 10000,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
});
service.defaults.transformRequest = function (data) {
    return qs.stringify(data);
};
service.interceptors.request.use(function (config) {
    console.log({ config: config });
    if (config.data.Token) {
        config.headers.Token = config.data.Token;
    }
    if (config.url.indexOf('tips_heartbeat') > 0) {
        config.headers.Songshu_Video = 'songShuAiDot';
    }
    return config;
}, function (error) {
    console.log(error);
    Promise.reject(error);
});
service.interceptors.response.use(function (response) {
    var res = response.data;
    console.log({ res: res });
    if (response.config.url.indexOf('tips_heartbeat') > 0 && response.status === 200) {
        return Promise.resolve({});
    }
    if (res.code == 200) {
        return Promise.resolve(res);
    } else {
        if (res.code === 1401) {
            console.error(res.message || '登录已过期\uFF0C请重新登录\uFF01');
        } else {
            console.error(res.message || '网络异常\uFF0C请稍后重试\uFF01');
        }
        return Promise.reject(res);
    }
}, function (error) {
    if (/timeout\sof\s\d+ms\sexceeded/.test(error.message)) {
        console.error('网络出了点问题\uFF0C请稍后重试\uFF01');
    }
    if (error.response) {
        switch (error.response.status) {
        case 404:
            console.error('请求的资源不存在\uFF01');
            break;
        case 500:
            console.error('内部错误\uFF0C请稍后重试\uFF01');
            break;
        case 503:
            console.error('服务器正在维护\uFF0C请稍等\uFF01');
            break;
        }
    }
    return Promise.reject(error.response);
});
var get = function get(url, params) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return service.get(url, _objectSpread(_objectSpread({}, config), {}, { params: params }));
};
var deletes = function deletes(url, params) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return service['delete'](url, _objectSpread(_objectSpread({}, config), {}, { params: params }));
};
var post = function post(url, params) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return service.post(url, params, config);
};
var put = function put(url, params) {
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return service.put(url, params, config);
};
export default {
    get: get,
    deletes: deletes,
    post: post,
    put: put
};